<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="date-filter">
  <div class="grid">
        <div *ngIf="role == 'SuperAdmin'" class="col-12 lg:col-2">
          <div class="date-outer">
            <label for="company">Company<span class="custom-star">*</span></label>
            <div class="custom-select2">
              <div class="filter-parking header-filter financials-filter">
                <p-multiSelect id="company" [options]="companyListWithAll" [(ngModel)]="selectedCompanies" optionLabel="name"
                            [defaultLabel]="'Select Companies'" (onChange)="onSelectionChange($event)">
                        </p-multiSelect>
                <img src="assets/images/fill-dropdown.svg" alt=""/>
              </div>
            </div>
            <div *ngIf="showAsterisk" class="validation-error">This field is required*</div>
          </div>
        </div>
        <div class="col-12 lg:col-2">
          <div class="date-outer">
            <label for="parkingLot">Parking Lot<span class="custom-star">*</span></label>
            <div class="custom-select2">
              <div class="filter-parking header-filter financials-filter">
                <p-multiSelect 
                id="parkingLot"
                [options]="parkingLotByStatesListWithAll" 
                [(ngModel)]="selectedParkingLots" 
                optionLabel="name"
                [defaultLabel]="'Select Parking Lots'"
                (onChange)="onParkingLotSelectionChange($event)"
               >
              </p-multiSelect>
                <img src="assets/images/fill-dropdown.svg" alt=""/>
              </div>
            </div>
            <div *ngIf="showParkingLotAsterisk" class="validation-error">This field is required*</div>
          </div>
        </div>
        <div class="col-12 lg:col-2">
          <div class="date-outer">
            <label for="dateRange">Date Range</label>
            <div class="custom-select2 custom-curser">
              <div class="filter-parking header-filter financials-filter">
                <p-dropdown id="dateRange" [options]="DateSlot" [(ngModel)]="selectedDateSlot" optionLabel="name" optionValue="value"
                  (onChange)="onDateSlotChange($event)"></p-dropdown>
                <img src="assets/images/fill-dropdown.svg" alt=""/>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf='showPicker' class="col-12 lg:col-2">
          <div class="date-outer">
            <label for="startDate">Start Date</label>
            <div class="custom-select2 custom-curser custom-date-calender">
              <div class="filter-parking header-filter">
                <p-calendar #startDate id="startDate" [(ngModel)]="startdate" [showTime]="false" placeholder="Select Date"></p-calendar>
                <img [calendarOpener]="startDate" src="assets/images/date-calender.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div *ngIf='showPicker' class="col-12 lg:col-2">
          <div class="date-outer">
            <label for="endDate">End Date</label>
            <div class="custom-select2 custom-curser custom-date-calender">
              <div class="filter-parking header-filter">
                <p-calendar #endDate id="endDate" [(ngModel)]="enddate" [showTime]="false" placeholder="Select Date"></p-calendar>
                <img [calendarOpener]="endDate" src="assets/images/date-calender.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div  *ngIf="!(role === 'SuperAdmin')" class="col-12 lg:col-2">
          <div class="date-outer">
            <label for="invoiceNumber">Invoice Number</label>
            <div class="custom-select2">
              <div class="filter-parking header-filter">
                <input type="text" id="invoiceNumber" pInputText placeholder="Enter Invoice Number" [(ngModel)]="invoiceNumber" />
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!showPicker" class="col-12 lg:col-2">
        <div class="date-outer">
          <label for="invoiceNumber">Invoice Number</label>
          <div class="custom-select2">
            <div class="filter-parking header-filter">
              <input type="text" id="invoiceNumber" pInputText placeholder="Enter Invoice Number" [(ngModel)]="invoiceNumber" />
            </div>
          </div>
        </div>
        </div>

<div class="col-12 lg:col-1">
          <div class="date-outer-btn">
            <div class="edit-outer">
              <p-button styleClass="p-button search-button" label="Search" (onClick)="searchButton()"></p-button>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-1">
          <div class="date-outer-btn">
            <div class="edit-outer reset-btn">
              <p-button styleClass="p-button  p-button-outlined" label="Reset" (onClick)="reset()"></p-button>
            </div>
          </div>
        </div>
        <div *ngIf="role === 'SuperAdmin' && showPicker " (click)="toggleHideAdvanceFilter()" class="hide-advance">
          <h5 *ngIf="!hideAdvanceFilter">Hide Advanced Filter</h5>
          <h5 *ngIf="hideAdvanceFilter">Advanced Filter</h5>
        </div>

<div  *ngIf="!hideAdvanceFilter && showPicker"class="col-12 lg:col-2">
          <div class="date-outer">
            <label for="invoiceNumber2">Invoice Number</label>
            <div class="custom-select2">
              <div class="filter-parking header-filter">
                <input type="text" id="invoiceNumber2" pInputText placeholder="Enter Invoice Number" [(ngModel)]="invoiceNumber" />
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

<p-tabView class="invoice-table">
  <p-tabPanel header="Current">
    <div class="booking-table1 booking-outer">
      <div class="invoice-title">
        <h4>History - Custom Invoices</h4>
        <div (click)="exportMenu();menu.toggle($event)"class="three-dot">
          <img src="assets/images/dashboard-dot.svg" alt="" />
        </div>
        </div>
        <div class="booking-table1 fullwidth-table-scroll common-heighttd booking-outer">
      <p-table id="tbl-top" [scrollable]="false" styleClass="p-datatable-striped" [value]="invoiceList"
        [tableStyle]="{ 'min-width': '50rem' }" [resizableColumns]="true" columnResizeMode="expand">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col" class="custom-addres">Name</th>
            <th scope="col">Invoice Number</th>
            <th scope="col">Email</th>
            <th scope="col">Mobile Number</th>
            <th scope="col">User Type</th>
            <th scope="col">Company</th>
            <th scope="col" class="invoice-lots">Parking Lot</th>
            <th scope="col">Arrival Date & Time</th>
            <th scope="col">Departure Date & Time</th>
            <th scope="col">Generated By</th>
            <th scope="col">Invoice Date</th>
            <th scope="col">Created Date</th>
            <th scope="col">Amount ($)</th>
            <th scope="col">Payment Mode</th>
            <th scope="col">Payment Status</th>
            <th scope="col" >Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-entry>
          <tr>
            <tr class="border12">
              <td class="driver-name custom-driver-name">
                <div class="history-table">
                    <img [src]="entry.profilePicture || 'assets/images/dummy-img.png'" alt="">
                    <p>{{ entry.userType === 'Group Operator' ? entry.groupName :
                        entry.name }}</p>
                </div>
            </td>
              <td>{{entry.invoiceNumber}}</td>
              <td>{{entry.email}}</td>
              <td>
                <div class="mobile-number"><span *ngIf="entry?.phoneNumber" [ngClass]="getFlagClass(entry?.iso)"></span> {{ entry?.phoneNumber ? entry.countryCode + ' ' + entry.phoneNumber : '-' }}</div>
              </td>
              <td>{{entry.userType}}</td>
              <td>{{entry.company}}</td>
              <td>
                <p class="parking-lot-text">{{entry.parkingLotName}}<br>
                  {{entry.address}}</p>
    
              </td>
              <td>{{entry.arrivalDate  || '-' }}</td>
              <td>{{entry.departureDate || '-'}}</td>
              <td>{{entry.generatedBy}}</td>
              <td>{{ entry.billingDate | customDate1}}</td>
              <td>{{entry.dateCreated}}</td>
              <td >{{entry.totalAmount}}</td>
              <td>{{entry.bookingPaymentMode | paymentModeValue}}</td>
              <td>
                <div class="big-parking"><p class="common-payment-status" [ngClass]="{
                  'pstatus-paid': entry.status === 'Paid',
                  }">{{entry.status}}</p></div>
                </td>
              <td >
                <div class="export-btn">
                  <img (click)="activeItem = entry;showData(entry);menu.toggle($event)"
                    src="assets/images/dashboard-dot.svg" alt="" />
                </div>
              </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
              <td class="no-record" colspan="13">
                  No Record Found
              </td>
          </tr>
      </ng-template>
      </p-table>
    </div>
      <div class="card common-content-end custom-pagination" *ngIf="invoiceList?.length > 0">
        <p-paginator [first]="first" [rows]="itemsPerPage" [totalRecords]="totalRecords"
          (onPageChange)="onPageChange($event)"></p-paginator>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
<div [ngClass]="{'export-btn': !isAlternateDesign, 'custom-export': isAlternateDesign }">
  <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>
